
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { DonationProvider } from "./context/DonationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <DonationProvider>
        <App />
      </DonationProvider>
    </AuthProvider>
  </React.StrictMode>
);
